import type { CommandAction } from '../../CommandPalette'
import type { BuildCommandActionsContext } from './types'

export const buildAccountCommandActions = ({ t, handleLogout }: BuildCommandActionsContext): CommandAction[] => [
  {
    id: 'logout',
    name: t('command.account.logout'),
    shortcut: ['meta', 'shift', 'l'],
    keywords: 'logout esci',
    perform: () => handleLogout(),
    group: t('command.group.account'),
    subtitle: t('command.account.logout.subtitle'),
  },
]
